import { ISignupLookup, ISignupWithQuestions, ISignupManagerWithQuestions, ISetPassword } from 'src/interfaces';
import axios, { AxiosError } from 'axios';
import http from './http';

class SignupService {
  static signup(data: ISignupWithQuestions, token: string) {
    return http.post('/auth/signup', data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }

  static signupManager(data: ISignupManagerWithQuestions) {
    return http.post('/auth/signup-manager-external', data, {});
  }

  static employeeSignupLookup(data: ISignupLookup) {
    return http
      .post('/auth/signup-token-lookup', data)
      .then(response => response.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static setPassword(token: string, data: ISetPassword) {
    return http
      .post(`/auth/set-password?token=${token}`, data)
      .then(response => response.data)
      .catch((err: AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message || 'Failed to set password');
        }
        throw err;
      });
  }

  static passwordSetupLookup(token: string) {
    return http.post('/auth/password-setup/lookup', { token }).then(res => res.data);
  }
}
export default SignupService;
